import { render } from "./S124812.vue?vue&type=template&id=77c4bdd4"
const script = {}
script.render = render

export default script